import $api from 'http'
import $apiJSON from 'http/apiJSON'


export async function getAssignments(params = {}) {
  return $api.get('/assignments/assignments/', { params })
}

export async function getPublishedAssignments(params = {}) {
  return $api.get('/assignments/assignments/', {
    params: { only_published: 1, ...params },
  })
}

export async function getAssignment(id) {
  return $api.get(`/assignments/assignments/${id}/`)
}

export async function createAssignment(data) {
  return $apiJSON.post('/assignments/assignments/', data)
}

export async function updateAssignment(id, data) {
  return $apiJSON.patch(`/assignments/assignments/${id}/`, data)
}

export async function deleteAssignment(id) {
  return $api.delete(`/assignments/assignments/${id}/`)
}


export async function getSubmissions(params = {}) {
  return $api.get('/assignments/submissions/', { params })
}

export async function getSubmission(id) {
  return $api.get(`/assignments/submissions/${id}/`)
}

export async function createSubmissionDraft(formData) {
  return $api.post('/assignments/submissions/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export async function updateSubmissionDraft(id, formData) {
  return $api.patch(`/assignments/submissions/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export async function submitSubmission(id) {
  return $apiJSON.post(`/assignments/submissions/${id}/submit/`, {})
}

export async function gradeSubmission(id, data) {
  return $apiJSON.post(`/assignments/submissions/${id}/grade/`, data)
}

export async function returnSubmission(id, data = {}) {
  return $apiJSON.post(`/assignments/submissions/${id}/return/`, data)
}

export async function getSubmissionsForReview(params = {}) {
  return $api.get('/assignments/submissions/', {
    params: { status: 'submitted', ...params },
  })
}

export async function getMySubmissions(studentId, params = {}) {
  return $api.get('/assignments/submissions/', {
    params: { student: studentId, ...params },
  })
}
